import { ChevronDown } from "@tamagui/lucide-icons";
import { Popover, XStack, YStack } from "tamagui";

import { Button } from "@/components/Button";
import { Text } from "@/components/Typography";
import { getShadow } from "@/theme/helpers";

const POPOVER_MIN_WIDTH = 160;

interface ListActionPopoverProps {
  label: string;
  valueText: string;
  options: { label: string; value: string }[];
  onSelect: (value: string) => void;
  dataTrackingId?: string;
}

export default function ListActionPopover({
  label,
  valueText,
  options,
  onSelect,
  dataTrackingId,
}: ListActionPopoverProps) {
  const ListActionTitle = options.find(
    (option) => option.value === valueText,
  )?.label;

  return (
    <Popover placement="bottom-end">
      <Popover.Trigger asChild>
        <Button.Wrapper
          untracked
          alignSelf="stretch"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text size="$sm">{label}</Text>
          <Popover.Anchor>
            <XStack alignItems="center" gap="$100">
              <Text size="$sm">{ListActionTitle}</Text>
              <ChevronDown />
            </XStack>
          </Popover.Anchor>
        </Button.Wrapper>
      </Popover.Trigger>
      <Popover.Content
        borderRadius="$150"
        backgroundColor="$fillCallout"
        borderWidth={0}
        {...getShadow({ y: 10, blur: "40px" })}
        zIndex={999999}
        padding="$100"
      >
        <YStack gap="$50" minWidth={POPOVER_MIN_WIDTH}>
          {options.map((option) => (
            <Popover.Close asChild key={option.value}>
              <Button
                onPress={() => onSelect(option.value)}
                dataTrackingId={dataTrackingId}
                mode="subMenu"
                role="menuitem"
                backgroundColor={
                  valueText === option.value ? "$navSelected" : "$transparent"
                }
              >
                <Text size="$sm" color="$textPrimary">
                  {option.label}
                </Text>
              </Button>
            </Popover.Close>
          ))}
        </YStack>
      </Popover.Content>
    </Popover>
  );
}
